import React from "react";
import { createRoot } from "react-dom/client";
import MetaDescriptionGenerator from "../components/free-tools/MetaDescriptionGenerator";
import ToastProvider from "../components/shared/ToastProvider";

document.addEventListener("DOMContentLoaded", () => {
  const rootElement = document.getElementById("meta-description-generator-main");
  if (rootElement) {
    const root = createRoot(rootElement);
    root.render(
      <>
        <ToastProvider />
        <MetaDescriptionGenerator />
      </>
    );
  }
});
